// Generated by purs version 0.14.4
import * as Control_Alt from "../Control.Alt/index.js";
import * as Control_Alternative from "../Control.Alternative/index.js";
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Apply from "../Control.Apply/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Category from "../Control.Category/index.js";
import * as Data_Boolean from "../Data.Boolean/index.js";
import * as Data_EuclideanRing from "../Data.EuclideanRing/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Int from "../Data.Int/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Ratio from "../Data.Ratio/index.js";
import * as Data_Rational from "../Data.Rational/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_String_CodePoints from "../Data.String.CodePoints/index.js";
import * as Data_String_Common from "../Data.String.Common/index.js";
var toStringR = function (r) {
    if (Data_Ratio.denominator(r) === 1) {
        return Data_Show.show(Data_Show.showInt)(Data_Ratio.numerator(r));
    };
    if (Data_Boolean.otherwise) {
        return Data_Show.show(Data_Show.showInt)(Data_Ratio.numerator(r)) + ("/" + Data_Show.show(Data_Show.showInt)(Data_Ratio.denominator(r)));
    };
    throw new Error("Failed pattern match at Data.Rational.Extra (line 38, column 1 - line 38, column 34): " + [ r.constructor.name ]);
};
var toRational = function (dict) {
    return dict.toRational;
};
var toString = function (dictAsRational) {
    var $13 = toRational(dictAsRational);
    return function ($14) {
        return toStringR($13($14));
    };
};
var fromRational = function (dict) {
    return dict.fromRational;
};
var fromString = function (dictAsRational) {
    return function (s) {
        var fromInt = function (s1) {
            return Data_Functor.map(Data_Maybe.functorMaybe)(Data_Rational.fromInt)(Data_Int.fromString(Data_String_Common.trim(s1)));
        };
        var fromFraction = function (s1) {
            var v = Data_String_Common.split("/")(s1);
            if (v.length === 2) {
                return Control_Bind.bind(Data_Maybe.bindMaybe)(Data_Int.fromString(Data_String_Common.trim(v[1])))(function (denominator) {
                    return Control_Bind.discard(Control_Bind.discardUnit)(Data_Maybe.bindMaybe)(Control_Alternative.guard(Data_Maybe.alternativeMaybe)(denominator !== 0))(function () {
                        return Control_Apply.apply(Data_Maybe.applyMaybe)(Data_Functor.map(Data_Maybe.functorMaybe)(Data_Ratio.reduce(Data_Ord.ordInt)(Data_EuclideanRing.euclideanRingInt))(Data_Int.fromString(Data_String_Common.trim(v[0]))))(Control_Applicative.pure(Data_Maybe.applicativeMaybe)(denominator));
                    });
                });
            };
            return Data_Maybe.Nothing.value;
        };
        var fromDecimalFraction = function (s1) {
            var v = Data_String_Common.split(".")(Data_String_Common.trim(s1));
            if (v.length === 2) {
                return Control_Bind.bind(Data_Maybe.bindMaybe)(Data_Int.fromString(v[0] + v[1]))(function (n) {
                    return Control_Applicative.pure(Data_Maybe.applicativeMaybe)(Data_Ratio.reduce(Data_Ord.ordInt)(Data_EuclideanRing.euclideanRingInt)(n)(Data_Int.pow(10)(Data_String_CodePoints.length(v[1]))));
                });
            };
            return Data_Maybe.Nothing.value;
        };
        return Data_Functor.map(Data_Maybe.functorMaybe)(fromRational(dictAsRational))(Control_Alt.alt(Data_Maybe.altMaybe)(Control_Alt.alt(Data_Maybe.altMaybe)(fromInt(s))(fromFraction(s)))(fromDecimalFraction(s)));
    };
};
var asRationalSerialized = {
    fromRational: Data_Newtype.wrap(),
    toRational: Data_Newtype.unwrap()
};
var asRationalPlain = {
    fromRational: Control_Category.identity(Control_Category.categoryFn),
    toRational: Control_Category.identity(Control_Category.categoryFn)
};
export {
    fromRational,
    toRational,
    toString,
    fromString,
    asRationalPlain,
    asRationalSerialized
};
export {
    denominator,
    fromInt,
    numerator,
    toNumber
} from "../Data.Rational/index.js";
//# sourceMappingURL=index.js.map
